module.exports = __webpack_public_path__ + "static/media/middas.ccaabe6a.png";